
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react'

import { eventLog } from './eventHelper';

// Components.

import HighlightSearchResults from './HighlightSearchResults';
import EpisodeSearchResults from './EpisodeSearchResults';
import { CloseRounded } from '@mui/icons-material';
import ProfilePicture from './ProfilePicture';
import { SegmentedTabPanels } from './SegmentedTabs';
import useSearchResultsSelection from './useSearchResultsSelection';

const HIGHLIGHT_EPISODE_TAB_OPTIONS = [
    { value: 'highlights', label: 'Highlights' },
    { value: 'episodes', label: 'Episodes' },
];

const AlgoliaSpeakerSearch = ({
    speaker,
    initialQuery,
    noQueryView,
    searchIntentKey = 0,
    initialResultsTab = 'highlights',

    // Redux.
}) => {
    const navigate = useNavigate();
    const scrollTargetRef = useRef(null);
    const options = HIGHLIGHT_EPISODE_TAB_OPTIONS;
    const selection = useSearchResultsSelection(JSON.stringify([speaker.id, searchIntentKey]), initialResultsTab, options);

    useEffect(() => {
        if (!!initialQuery) {
            eventLog(13, {
                'topicId': initialQuery,
            });
        }
    }, [initialQuery]);

    const query = (initialQuery || '').trim();

    useEffect(() => {
        document.getElementById('audio')?.pause();
    }, [query, speaker.id]);

    const searchAllPodcasts = () => {
        navigate('/search/' + encodeURIComponent(query));
    }

    return (
        <div>
            {!!query ?
                <div style={{ padding: '0px 0px 20px 0px' }}>
                    <div ref={scrollTargetRef} style={{ paddingTop: '72px' }} />
                    <div className='scopedSearchHeader'>
                        <button onClick={searchAllPodcasts} className='clampSafeButton scopedSearchFilterChip'>
                            <ProfilePicture
                                speakerId={speaker.id}
                                borderSize={1}
                                imageSrc={speaker.imageURL}
                                size='28px'
                                margin='0px' />
                            <span className='oneline scopedSearchFilterChipLabel'>
                                {speaker.name}
                            </span>
                            <CloseRounded className='scopedSearchFilterChipClose' style={{ fontSize: '18px' }} />
                        </button>
                    </div>
                    <SegmentedTabPanels
                        resetKey={speaker.id}
                        scrollResetKey={JSON.stringify([query, speaker.id])}
                        {...selection}
                        hideSingleOption
                        scrollTargetRef={scrollTargetRef}
                        stickyControlTop='74px'
                        options={options}
                        panels={{
                            highlights: <HighlightSearchResults query={query} speakerId={speaker.id} entityName={speaker.name} onSearchEpisodes={() => selection.onChange('episodes')} />,
                            episodes: <EpisodeSearchResults query={query} titleSpeakerId={speaker.id} entityName={speaker.name} />,
                        }}
                        controlPadding='14px 20px 10px'
                        fontSize='14px'
                        buttonPadding='6px 0px'
                    />
                </div>
                :
                noQueryView
            }
        </div>
    );
};

const mapStateToProps = (state) => ({

})

const mapActionsToProps = {

}

export default connect(mapStateToProps, mapActionsToProps)(AlgoliaSpeakerSearch);
